import React, { useEffect, useState } from 'react';
import { LoadingStyled } from '../../stylesheets/Loading.style';
import VisuallyHidden from '../Atoms/VisuallyHidden/VisuallyHidden';

const LoginLoadingIndicator = ({ content }) => {
  const [loadingText, setLoadingText] = useState('');
  const [displayText, setDisplayText] = useState(content);

  useEffect(() => {
    // Inject after mount so the live region announces the change
    setLoadingText('Loading...');

    const timeout = setTimeout(() => {
      setDisplayText(
        <>
          If you are a student experiencing issues logging in, please inform your teacher.
          If you are a teacher or administrator experiencing issues logging in, please visit our{' '}
          <a href="https://helpdesk.chalktalk.com">helpdesk</a> or send an email to{' '}
          <a href="mailto:support@chalktalk.com">support@chalktalk.com</a>.
        </>,
      );
    }, 10 * 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <LoadingStyled role='main'>
      <VisuallyHidden as="h1">Loading</VisuallyHidden>
      <div className="container">
        <div className="cube">
          <div className="sides">
            <div className="top" />
            <div className="right" />
            <div className="bottom" />
            <div className="left" />
            <div className="front" />
            <div className="back" />
          </div>
        </div>
        <div className="text">
          <p role="status" aria-live="polite">{loadingText}</p>
          <p>{displayText}</p>
        </div>
      </div>
    </LoadingStyled>
  );
};

export default LoginLoadingIndicator;
